import React from 'react';
import { Checkbox } from '@cainiaofe/cn-ui';

export default class CheckboxSetter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { value, onChange } = this.props;
    return (
      <Checkbox
        checked={value}
        onChange={(v) => {
          onChange?.(v);
        }}
      />
    );
  }
}
